<template>
  <div class="formPanel clear">
    <div class="panel">
      <p>Please complete the details below and submit your video competition entry. Remember to send us the correct link to your finished video on either Youtube or Vimeo.</p>
      <div v-if="!success">
        <form enctype="multipart/form-data" >
          <label for="email">Email address</label>
          <input type="email" id="email" v-model="email" @input="onChange">
          <label for="title">Video title</label>
          <input type="text" id="title" v-model="title" @input="onChange">
          <label for="author">Video Author</label>
          <input type="text" id="author" v-model="author" @input="onChange">
          <label for="link">Link to the video (Vimeo/Youtube/BiliBili only)</label>
          <input type="text" id="link" placeholder="i.e. https://vimeo.com/300402134" v-model="link" @input="onChange">
          <label v-if="isBiliBili" for="link">Add thumbnail <br>(JPG files less than 1Mb minimum 460px by 250px)</label>
          <input v-if="isBiliBili" type="file" id="link" @input="onFileChange($event.target)" accept="image/jpeg">

          <label class="checkbox" for="terms">
            <input type="checkbox" id="terms" v-model="termsAgree" @change="onChange">
            I have read and understood the iFootage Video Competition Terms and Conditions.
          </label>
        </form>
        <div class="errors">
          <ul>
            <li class="field-validation-error" v-for="(item, index ) in errors" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="alignCenter">
          <Button @click.native="onSubmit">Submit your entry</Button>
        </div>
      </div>
      <div class="field-validation-success" v-if="success">
        You have submitted your video successfully.
      </div>
    </div>

  </div>
</template>

<script>
import Button from './elements/Button'
import { api } from '@/config'
import axios from 'axios'
import getVideoId from '@/utils/getVideoId.js'
export default {
  name: 'SubmissionForm',
  components: {
    Button
  },
  data() {
    return {
      title: '',
      author: '',
      link: '',
      convertedLink: '',
      email: '',
      termsAgree: '',
      code: '',
      image: {},
      errors: [],
      success: false,
      isBiliBili: false
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.code = this.$route.query.code
    } else {
      this.errors.push('Invalid submission link. Check you email for your assigned submission link.')
    }
  },
  methods: {
    checkForErrors() {
      this.errors = []
      if (this.title === '' || this.author === '' || this.link === '' || this.email === '') {
        this.errors.push('Fill in all fields')
      }
      if (!this.termsAgree) {
        this.errors.push('You have to accept the terms and conditions.')
      }

      if (!this.isValidVideoId()) {
        this.errors.push('Video link must be a valid vimeo, youtube or bilibili link.')
      }

      if(this.isBiliBili && !this.image[0]) {
        this.errors.push('You need to add a thumbnail.')
      }
    },

    onChange() {
      this.errors = []
      if(this.link && this.link.includes('bilibili')) {
        this.isBiliBili = true
      } else {
        this.isBiliBili = false
      }
    },
    onFileChange(target) {
      this.image = target.files
    },

    onSubmit() {
      this.checkForErrors()

      if (this.errors.length < 1) {
        const formData = new FormData()
        formData.append('title', this.title)
        formData.append('author', this.author)
        formData.append('linkId', this.convertedLink.id)
        formData.append('linkService', this.convertedLink.service)
        formData.append('email', this.email)
        formData.append('code', this.code)
        if(this.image[0]) {
          formData.append('videoThumb', this.image[0], `${this.convertedLink.id}.jpg`)
        }

        axios.post(api.submissions, formData).then(response => {
          if (response.data.status === 'success') {
            this.success = true
          } else {
            this.errors = response.data.errors
          }
        }).catch(err => {
          if(err && err.response.data && err.response.data.errors.length > 0) {
            this.errors.push(err.response.data.errors[0])
          } else {
            this.errors.push('There was a database error. Please contact support.')
          }
        })
      }
    },

    isValidVideoId() {
      const video = getVideoId(this.link)
      if (video.id && video.service) {
        this.convertedLink = video
        return true
      } else {
        this.convertedLink = ''
        return false
      }
    },
  }
}
</script>
